import { render, staticRenderFns } from "./taizhoudosageagreement.vue?vue&type=template&id=6ff31420&"
var script = {}
import style0 from "./taizhoudosageagreement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports